module.exports = __webpack_public_path__ + "img/dgjg2335_1.cda858bb.svg";